import { GuidedTour } from "./GuidedTour";
export default GuidedTour;
